<template>
  <div class="share-box">
    <van-nav-bar
      title="复制链接"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="share-body">
      <template v-if="user.id">
        <div class="estimate">奖励预估收益 <span class="c-red">{{ promotion_rate }}</span> 元</div>
      </template>
      <template v-else>
        <router-link class="c-red" :to="'/login?redirect=' + $route.fullPath"
          >登录</router-link
        >后才能获取佣金
      </template>
      <textarea class="content" :value="shareText" disabled> </textarea>
    </div>

    <div class="share-footer">
      <div class="share-footer-layer">
        <van-button
          type="warning"
          round
          size="large"
          @click="copy(materialUrl)"
          >复制链接</van-button
        >
        <van-button type="warning" round size="large" @click="copy(shareText)"
          >分享素材</van-button
        >
        <van-button type="danger" round size="large" @click="go()"
          >前往购买</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      active: 1,
      goodInfo: {
        couponInfo:{},
        priceInfo:{},
        commissionInfo:{},
      }, //商品详情
    };
  },
  created() {
     const jdGoodInfo =
      JSON.parse(window.localStorage.getItem("jdGoodInfo")) || {};
    this.Post(
      { skuId: this.$route.query.id },
      "/jd/goodPromotiongoodsinfoQuery",
      (res) => {
        if (res.states == 1) {
          const data = JSON.parse(
            res.data.jd_union_open_goods_promotiongoodsinfo_query_response
              .result
          );
          if (data.code === 200) {
            let goodInfo = data.data[0] || {};
            if (goodInfo.skuId === jdGoodInfo.skuId) {
              goodInfo = {
                ...jdGoodInfo,
                ...goodInfo,
              };
            }
            this.goodInfo = goodInfo;
            console.log(goodInfo);
            if(goodInfo.imageInfo.imageList){
              this.images = goodInfo.imageInfo.imageList.map(item=>item.url)
            }else{
              this.images = [goodInfo.imgUrl]
            }
          }
        }
      }
    );
  },
  computed: {
    ...mapState(["rate", "user"]),
    materialUrl(){
      let url = this.goodInfo.materialUrl
      if(this.goodInfo.couponInfo.couponList){
         const couponList = this.goodInfo.couponInfo.couponList.sort((a,b)=>{
           return b.discount - a.discount
         })
          url = couponList[0].link;
      }
      return url;
    },
    shareText() {
      const text = `
${this.goodInfo.goodsName} \n
【到手价】: ${this.goodInfo.priceInfo.lowestCouponPrice || this.goodInfo.unitPrice}元 \n
下单链接:${this.materialUrl}
`;
      return text;
    },
    // 佣金折算
    promotion_rate() {
      return (
        (this.goodInfo.commissionInfo.couponCommission *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  methods: {
    go() {
      window.location.href = this.materialUrl;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../assets/less/share.less";
</style>



// WEBPACK FOOTER //
// src/pages/jd/share.vue